var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',_vm._b({staticClass:"my-2",style:({ cursor: _vm.cursor ? 'pointer' : 'default' }),attrs:{"small":"","color":_setup.getApprovalChipColor(_vm.item.approvalPhase)}},'v-chip',Object.assign({}, _vm.$attrs, _vm.chipProps),false),[_vm._v(" "+_vm._s(_vm.item.approvalPhase)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }